import * as _ from "lodash";

/**
 * Utility class for neutralization.
 * For CWE-80 vulnerability: Improper Neutralization of Script-Related HTML Tags in a Web Page (Basic XSS)
 * The code scan may raise false alarms for codes that are not really HTML. Use this class to escape the false positive.
 * Right now, the methods simply return the given object.
 */
export class NeutralizeUtils {
    static NeutralizeString(value: string): string {
        return value;
    }

    static NeutralizeArray(array: any[]): any[] {
        const result: any[] = [];
        for (const item of array) {
            if (_.isString(item)) {
                result.push(NeutralizeUtils.NeutralizeString(item));
            } else if (_.isArray(item)) {
                result.push(NeutralizeUtils.NeutralizeArray(item));
            } else if (_.isPlainObject(item)) {
                result.push(NeutralizeUtils.NeutralizeJSON(item));
            } else {
                result.push(item);
            }
        }
        return result;
    }

    static NeutralizeJSON(obj: any): { [key: string]: any } {
        const result: { [key: string]: any } = {};
        for (const key in obj) {
            const value = obj[key];
            if (_.isString(value)) {
                result[key] = NeutralizeUtils.NeutralizeString(value);
            } else if (_.isArray(value)) {
                result[key] = NeutralizeUtils.NeutralizeArray(value);
            } else if (_.isPlainObject(value)) {
                result[key] = NeutralizeUtils.NeutralizeJSON(value);
            } else {
                result[key] = value;
            }
        }
        return result;
    }
}
